/**
 * « Nouveau projet » de la barre de gauche (chantier `navigation`, 01) : il mène à Projets avec
 * cet état, et la page y ouvre la saisie du nom, la création d'aujourd'hui (`NouveauProjet`).
 */
export const OUVRIR_LA_SAISIE_DU_PROJET = { ouvrirLaSaisieDuProjet: true } as const;

/** L'état de l'adresse demande-t-il la saisie du nom d'un projet ? */
export function saisieDuProjetDemandee(etat: unknown): boolean {
  return typeof etat === 'object' && etat !== null && (etat as Record<string, unknown>).ouvrirLaSaisieDuProjet === true;
}
